import BreadCrumb from './bread_crumb'

export default {
    install: function(Vue) {
        Vue.component('BreadCrumb', BreadCrumb)
    }
}